import React from 'react';
import GeneralModal from '../../../../components/GeneralModal/GeneralModal';
import { useEquipmentActivateMutation, useEquipmentUnarchivedMutation } from '../../../../store/builder/inspections.api';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../../hooks/useTranslation';

const ActivateToolModal = ({ toolId, setIsOpen, onActivateSuccess, isArchived }) => {
  const {t} = useTranslation();
  const [
    activate,
    { isLoading: activateIsLoading },
  ] = useEquipmentActivateMutation();
  const [
    unarchive,
    { isLoading: unarchiveIsLoading },
  ] = useEquipmentUnarchivedMutation();

  const handleActivate = () => {
    const action = isArchived ? unarchive : activate;
    const isLoading = isArchived ? unarchiveIsLoading : activateIsLoading;
    
    action(toolId).then((res) => {
      if (res?.data?.message) {
        toast.success(res?.data?.message);
      }
      if (res?.error) {
        toast.error(res?.error?.data?.message);
      }
      setIsOpen(false);
      if (onActivateSuccess) {
        onActivateSuccess();
      }
    });
  };

  return (
    <GeneralModal
      title={isArchived ? t('equipmentTable.modals.unarchive.title') : t('equipmentTable.modals.activate.title')}
      onClose={() => setIsOpen(false)}
      onSubmit={handleActivate}
      submitTitle={isArchived ? t('equipmentTable.actions.unarchive') : t('equipmentTable.actions.activate')}
      cancelTitle={t('toolsManagement.modals.buttons.close')}
      btnType='save'
      disableSubmit={isArchived ? unarchiveIsLoading : activateIsLoading}
    >
      <div className='modal__content-body'>
        <p>{isArchived ? t('equipmentTable.messages.unarchiveEquipment') : t('equipmentTable.messages.activateEquipment')}</p>
      </div>
    </GeneralModal>
  );
};

export default ActivateToolModal;
